module.exports = __webpack_public_path__ + "img/airport-light.4596f0ab.png";